import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { usePermission } from 'providers/RightsHooks';
import { ADMIN_COMMISSIONS_WRITE } from 'constants/rightsCodes';

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();

  const canWrite = usePermission(ADMIN_COMMISSIONS_WRITE);
  return (
    <IconButton
      disabled={!canWrite}
      type='add'
      fontSize='medium'
      color='transparent'
      tooltip={t('Tooltips.LeasingCommission.AddNewLeasingCommission')}
      onClick={onAdd}
    />
  );
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
